module.exports = {
	"classes": [
		"jobs-page",
		"header"
	],
	"title": "Jobs",
	"metas": {
		"description": "Jobs. We are always looking for talented people to join our team."
	},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/jobs/metadata.json
// module id = 1122
// module chunks = 0